import React from "react";


const DataTableCheckboxCell = React.forwardRef(({ onClick, ...rest }, ref) => {
    //console.log('Checkbox ref',ref,rest);
    return (
      <div className="form-check">
        <input
          htmlFor="booty-check"
          type="checkbox"
          className="form-check-input"
          ref={ref}
          onClick={onClick}
          {...rest}
        />
        <label className="form-check-label" id="booty-check" />
      </div>
    );
});

export default DataTableCheckboxCell;